import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

/**
 * V2 typography utilities (`.text-page-title`, `.text-section`, `.text-body`,
 * `.text-label`, `.text-caption`) set font-size + font-weight + line-height.
 * Register them in the `font-size` conflict group so twMerge keeps them when
 * combined with `text-foreground` / `text-muted-foreground` (which are colors).
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        { text: ["page-title", "section", "body", "label", "caption"] },
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
